import {
  Container,
  Text,
  ContainerPadding,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { Offer, OfferEquipment, OfferEquipments } from '../types';
import { EquipmentTitle } from './EquipmentTitle';

export interface CarlineEquipmentsProps {
  equipments: OfferEquipments;
  offer?: Offer;
}

export function CarlineEquipments(props: CarlineEquipmentsProps) {
  const { serie } = props.equipments;

  return (
    < >
      {serie.length > 0 ? (
        <>
          <Container padding={{ bottom: ContainerPadding.static200 }}>
            <Text appearance={TokenTextAppearance.copy200} bold>
              Equipamiento
            </Text>
          </Container>
          <Container wrap={"always"}>
            {serie.slice(0, 7).map((equipment: OfferEquipment, index) => {
              return (
                <EquipmentTitle
                  title={equipment.equipamiento.titulo}
                  key={index}
                  isLastItem={index === 6 || index === serie.length - 1 ? true : false}
                />
              );
            })}
          </Container>
        </>
      ) : null}
    </>
  );
}
